module.exports = __webpack_public_path__ + "img/TREASURY.7e2eddc4.svg";